<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div v-if="loading" class="w-full bg-gray-200 rounded-full h-1 overflow-hidden mb-4">
        <div class="bg-primary h-1 rounded-full animate-pulse" style="width: 100%"></div>
      </div>

      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
              <div class="border-b border-gray-200">
                <nav class="flex space-x-6 px-4" aria-label="Tabs">
                  <div
                    :class="[(currentRoute === 'forms') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
                    @click="select('forms')"
                  >
                    <div class="flex items-center">
                      <span class="text-sm font-medium">Application Information</span>
                    </div>
                  </div>
                  <div
                    :class="[(currentRoute === 'attachments') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
                    @click="select('attachments')"
                  >
                    <div class="flex items-center">
                      <span class="text-sm font-medium">Attachments</span>
                    </div>
                  </div>
                  <div
                    :class="[(currentRoute === 'messages') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
                    @click="select('messages')"
                  >
                    <div class="flex items-center">
                      <span class="text-sm font-medium">Messages</span>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-4">
            <div class="col-span-12 mx-auto">
              <WindingInsolvencyForms v-if="currentRoute === 'forms' && task" :task="task" />
              <InsolvencyFormFiles v-if="currentRoute === 'attachments' && task" :task="task" />
              <InsolvencyMessages v-if="currentRoute === 'messages' && task" :task="task" mode="THREAD" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useConfigurationsStore } from "../../../stores";
import WindingInsolvencyForms
  from "@/domains/home/services/configurations/views/settings/insolvency/WindingInsolvencyForms.vue";
import InsolvencyMessages
  from "@/domains/home/services/configurations/views/settings/insolvency/InsolvencyMessages.vue";
import InsolvencyFormFiles
  from "@/domains/home/services/configurations/views/settings/insolvency/InsolvencyFormFiles.vue";

const props = defineProps({
  trackingNumber: String,
})

const store = useConfigurationsStore();
const route = useRoute()
const currentRoute = ref('forms')
const loading = ref(false)
const task = ref<any>(null)

const select = (routeName: string) => {
  currentRoute.value = routeName
}

const fetchDraftData = (trackingNumber: string) => {
  if (route.path.includes('winding-up')) {
    store.fetchWindingDraftData(trackingNumber);
  }
}

onMounted(() => {
  if (props.trackingNumber) {
    loading.value = true
    fetchDraftData(props.trackingNumber)
  }
})

watch(
  () => props.trackingNumber,
  (data) => {
    if (data) {
      loading.value = true
      store.fetchWindingDraftData(data);
    }
  }
)

watch(
  () => store.windingDraftData,
  (data) => {
    if (data) {
      loading.value = false
      task.value = data.data
    }
  }
)

watch(
  () => store.windingDraftDataError,
  (error) => {
    if (error) {
      loading.value = false
    }
  }
)
</script>
